import { IconButton, InputAdornment, TextField, TextFieldProps } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { commonInputStyle } from '../CustomFormsComponents/CustomField';
import React from 'react';

export interface InputProps extends Omit<TextFieldProps, 'onChange' | 'value' | 'name' | 'error'> {
    type?: string;
    label?: string;
    required?: boolean;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    name?: string;
    value?: string | number | null;
    disabled?: boolean;
    readOnly?: boolean;
    errors?: Record<string, string> | null;
    size?: 'small' | 'medium';
    width?: string;
    clearable?: boolean;
    autoComplete?: 'on' | 'off';
    placeholder?: string;
    endIcon?: React.ReactNode;
    onKeyDown?: () => void;
    onBlur?: React.FocusEventHandler<HTMLInputElement>;
    borderColor?: string | null;
    testID?: string;
}

const Input: React.FC<InputProps> = ({
    type = 'text',
    label = '',
    required = false,
    onChange,
    name,
    value,
    disabled,
    readOnly,
    errors = null,
    size = 'small',
    width,
    clearable = false,
    autoComplete = 'off',
    placeholder,
    endIcon,
    onKeyDown,
    onBlur,
    borderColor = null,
    testID
}) => {
    return (
        <TextField
            className="input-textfield"
            aria-readonly
            disabled={disabled}
            type={type}
            style={{ width }}
            label={label}
            size={size}
            fullWidth
            value={value ?? ''}
            name={name}
            sx={{
                ...(borderColor && {
                    '& fieldset': {
                        borderColor: `${borderColor} !important`,
                        borderWidth: '1px !important'
                    },
                    '& label': {
                        color: '#000 !important'
                    }
                }),
                ...commonInputStyle
            }}
            helperText={errors && name && errors[name] ? errors[name] || 'Campo incorrecto' : ''}
            error={!!(errors && name && errors[name])}
            placeholder={placeholder}
            required={required}
            onBlur={onBlur}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                onChange?.(e);
            }}
            inputProps={{
                'data-testid': testID
            }}
            InputProps={{
                onKeyDown: (e) => {
                    if (e.key === 'Enter') {
                        onKeyDown?.();
                    }
                },
                readOnly,
                autoComplete,
                endAdornment:
                    type === 'search' ? (
                        <InputAdornment position="end">
                            <IconButton aria-label="search" edge="end">
                                <SearchIcon />
                            </IconButton>
                        </InputAdornment>
                    ) : clearable && value ? (
                        <InputAdornment position="end">
                            <IconButton
                                aria-label="clear input"
                                onClick={() => {
                                    onChange?.({
                                        target: {
                                            value: '',
                                            name: name ?? ''
                                        }
                                    } as unknown as React.ChangeEvent<HTMLInputElement>);
                                }}
                                edge="end"
                            >
                                <HighlightOffIcon color="primary" />
                            </IconButton>
                        </InputAdornment>
                    ) : endIcon ? (
                        <InputAdornment position="end">{endIcon}</InputAdornment>
                    ) : null
            }}
        />
    );
};

export default Input;
